import { MediaElement } from 'editor/src/store/design/types';

/**
 * A "static" design element — marked static via "make static" (`static`) and not owned by a
 * layout, e.g. a merchant's fixed background/decoration. Such elements must survive a layout
 * switch untouched (GAPI-45762): they are held out of the layout reflow and re-added verbatim
 * rather than being repositioned into a layout frame. Layout-owned frames (`createdByLayout`) can
 * also carry `static`, so they are excluded here and regenerated as normal.
 */
const isStaticElement = (element: MediaElement) => {
  const el = element as { static?: boolean; createdByLayout?: boolean };
  return !!el.static && !el.createdByLayout;
};

export default isStaticElement;
